import { Box, Typography } from "@mui/material";
import React, { CSSProperties, useEffect, useState } from "react";
import { MoonLoader } from "react-spinners";
import { SPColor } from "../../constants/color";
import { School, SchoolLeader } from "../../types/record";
import Loading from "../Loading/Loading";
import SPSelect from "../SPSelect/SPSelect";
import LeaderBoard from "./LeaderBoard";

type WeekType = {
  tag: string;
  name: string;
};

type SchoolLeaderPageProp = {
  schools: School[];
  weeks: WeekType[];

  cityId: string | null;
  subject: string | null;
};

const override: CSSProperties = {
  display: "block",
  margin: "0 auto",
  borderColor: "red",
};

export default function SchoolLeaderPage({
  schools,
  weeks,

  cityId,
  subject,
}: SchoolLeaderPageProp) {
  const [list, setList] = useState<SchoolLeader[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [schoolId, setSchoolId] = useState<string | number>("");

  const [weekTag, setWeekTag] = useState("");

  useEffect(() => {
    if (schoolId && weekTag) {
      setLoading(true);
      fetch(
        `${process.env.REACT_APP_API_URL}/api/class-leader/${schoolId}?week=${weekTag}&cityId=${cityId}&subject=${subject}`
      )
        .then((response) => response.json())
        .then((data) => {
          const list = JSON.parse(data.data);
          console.log("--=list==--  ", list);
          setList(
            list.sort((a: SchoolLeader, b: SchoolLeader) =>
              a.place > b.place ? 1 : -1
            )
          );
          setLoading(false);
        });
    } else {
      setList([]);
    }
  }, [schoolId, weekTag]);

  if (loading) {
    return <Loading />;
  }

  return (
    <Box
      sx={{
        textAlign: "center",
        margin: "auto",
        maxWidth: "md",
      }}
    >
      <Box
        sx={{
          marginTop: 1,
          width: "100%",
          display: "flex",

          flexDirection: { sm: "row", xs: "column-reverse" },
          gap: "12px",
          flexWrap: "wrap",
        }}
      >
        <Box flex={1}>
          {weeks && (
            <SPSelect
              items={weeks?.map((item) => ({
                label: item.name,
                value: item.tag,
              }))}
              onChange={(e: number | string) => setWeekTag(e.toString())}
              defaultValue={weekTag}
              bgColor={SPColor.WHITE}
              sx={{
                borderColor: "black",
                width: "100%",
                "& .MuiOutlinedInput-notchedOutline, & .MuiSelect-outlined, & .MuiSelect-select":
                  {
                    padding: "4px 28px 4px 16px",
                    borderColor: SPColor.ORANGE + " !important",
                    borderWidth: "2px !important",
                    border: "solid",
                  },
              }}
              placeholder="בחר תקופה"
              name={"school"}
            />
          )}
        </Box>
        <Box
          flex={1}
          sx={{
            mt: { sm: 0, xs: 2 },
          }}
        >
          {schools && (
            <SPSelect
              items={schools?.map((item) => ({
                label: item.name,
                value: item.id,
              }))}
              onChange={(e: number | string) => setSchoolId(e)}
              defaultValue={schoolId}
              bgColor={SPColor.WHITE}
              sx={{
                borderColor: "black",
                width: "100%",
                "& .MuiOutlinedInput-notchedOutline, & .MuiSelect-outlined, & .MuiSelect-select":
                  {
                    padding: "4px 28px 4px 16px",
                    borderColor: SPColor.ORANGE + " !important",
                    borderWidth: "2px !important",
                    border: "solid",
                  },
              }}
              placeholder="בחר בית ספר"
              name={"school"}
            />
          )}
        </Box>
      </Box>
      <Box>
        {/* table header */}
        {weekTag && schoolId && (
          <Box
            sx={{
              mt: 1,
              borderRadius: "5px",
              backgroundColor: SPColor.SYSTEM1,
              display: "flex",
              color: "white",

              py: { sm: 0, xs: 1 },
            }}
          >
            <Box
              sx={{
                width: "140px",
                display: "flex",
                alignItems: "center",
                justifyContent: {
                  sm: "center",
                  xs: "space-around",
                },
                flexDirection: {
                  sm: "row",
                  xs: "column",
                },
              }}
            >
              <Typography
                sx={{
                  fontWeight: "bold",
                }}
                className="title-text"
              >
                כוכבים
              </Typography>
              <Typography
                sx={{
                  fontWeight: "bold",
                  display: { sm: "none", xs: "flex" },
                }}
                className="title-text"
              >
                שעות
              </Typography>
            </Box>
            <Box sx={{ flex: 1, px: 1, display: { sm: "flex", xs: "none" } }}>
              <Box
                sx={{
                  display: "flex",
                  height: "50px",
                }}
              >
                <Box
                  sx={{
                    width: "100px",
                    p: "2px",
                    margin: "5px",
                  }}
                  className="title-text"
                >
                  <Typography
                    sx={{
                      mr: 2,
                      fontWeight: "bold",
                    }}
                  >
                    שעות
                  </Typography>
                </Box>
                <Box
                  sx={{ width: "100px", p: "2px", margin: "5px" }}
                  className="title-text"
                >
                  <Typography
                    sx={{
                      mr: 2,
                      fontWeight: "bold",
                    }}
                  >
                    פעילים
                  </Typography>
                </Box>
                <Box
                  sx={{ width: "100px", p: "2px", margin: "5px" }}
                  className="title-text"
                >
                  <Typography
                    sx={{
                      mr: 2,
                      fontWeight: "bold",
                    }}
                  >
                    תלמידים
                  </Typography>
                </Box>
              </Box>

              <Box sx={{ flex: 1 }} className="title-text">
                <Typography sx={{ fontWeight: "bold" }}>
                  כיתה / קבוצה
                </Typography>
              </Box>
            </Box>

            <Box
              sx={{
                flex: 1,
                px: 1,
                display: { sm: "none", xs: "flex" },
                flexDirection: "column",
                justifyContent: "space-around",
              }}
            >
              <Box sx={{ flex: 1 }}>
                <Typography
                  sx={{ fontWeight: "bold", textAlign: "right", pr: 2 }}
                >
                  כיתה / קבוצה
                </Typography>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  // height: "50px",
                }}
              >
                <Box
                  sx={{ width: "100px", px: "2px", mx: "5px" }}
                  className="title-text"
                >
                  <Typography
                    sx={{
                      mr: 2,
                      fontWeight: "bold",
                    }}
                  >
                    פעילים
                  </Typography>
                </Box>
                <Box
                  sx={{ width: "100px", px: "2px", mx: "5px" }}
                  className="title-text"
                >
                  <Typography
                    sx={{
                      mr: 2,
                      fontWeight: "bold",
                    }}
                  >
                    תלמידים
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>
        )}

        {/* table header end */}

        {list.map((item: SchoolLeader) => (
          <LeaderBoard item={item} key={item.id} type="school" />
        ))}
      </Box>
    </Box>
  );
}
